module.exports = __webpack_public_path__ + "img/desc_bottom_blhsg03.d969ef11.png";